function filterIcon(props) {
  return (
    <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 5L5 1L9 5" stroke="#1C1E26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 9L5 13L9 9" stroke="#1C1E26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
export default filterIcon;